// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM_TOPIC_EDIT_USERNAME_YOU_WANNA_ADD = "Zadaj meno pou\u017e\u00edvate\u013eky, ktor\u00fa chce\u0161 prida\u0165 ako moder\u00e1torku";
